import { Selector, State, StateContext, createSelector } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { Injectable, Injector } from '@angular/core';
import { ENDPOINTS } from 'src/app/@config';
import { IdNamePair } from 'src/app/@models';
import { DropdownService } from 'src/app/@services';

@State<IdNamePair[]>({
  name: 'leadStatus',
  defaults: []
})
@Injectable()
export class LeadStatusState {
  private static dropdownService: DropdownService

  static hasAny() {
    return createSelector([LeadStatusState], (state: IdNamePair[]) => {
      return state?.length > 0;
    });
  }

  @Selector()
  static isEmpty(state: IdNamePair[]): boolean {
    return state.length === 0;
  }
  
  static getById(id: number) {
    return createSelector([LeadStatusState], (state: IdNamePair[]) => {
      return state.find((x: IdNamePair)=> x.id === id).name;
      
    });
  }

  constructor(injector: Injector) {
    LeadStatusState.dropdownService = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<IdNamePair[]>) {
    this.dropdownService.getDropdownData(ENDPOINTS.getLeadStatusList()).subscribe((data: IdNamePair[]) => setState(data));
  }
}
